(function ($) {
    $(function () {
        /**
         * MENU
         */
        $('.js-burger').click(function (e) {
            e.preventDefault();

            var target = $($(this).attr('href'));

            target.slideToggle();
        });

        $('body').on('click', '.js-display-sub-menu, .menu-item-has-children > a[href="#"]', function (e) {
            e.preventDefault();

            $(this).siblings('.sub-menu').slideToggle();
        });

        /**
         * HEADER
         */
        var header = $('.js-header.header--float'),
            headerHeight = header.outerHeight(),
            headerDark = header.hasClass('dark')
        ;

        $(window).scroll(function () {
            if ($(this).scrollTop() > headerHeight) {
                header.addClass('header--sticky');
                headerDark && header.removeClass('dark');
            } else {
                header.removeClass('header--sticky');
                headerDark && header.addClass('dark');
            }
        });

        /**
         * POPUP
         */
        $.extend(true, $.magnificPopup.defaults, {
            tClose: 'Fermer (Esc)', // Alt text on close button
            tLoading: 'Chargement...', // Text that is displayed during loading. Can contain %curr% and %total% keys
            gallery: {
                tPrev: 'Précédent (touche flèche gauche)', // Alt text on left arrow
                tNext: 'Suivant (touche flèche droite)', // Alt text on right arrow
                tCounter: '%curr% sur %total%' // Markup for "1 of 7" counter
            },
            image: {
                tError: '<a href="%url%">L\'image</a> n\'a pas pu être chargé.' // Error message when image could not be loaded
            },
            ajax: {
                tError: '<a href="%url%">Le contenu</a> n\'a pas pu être chargé.' // Error message when ajax request failed
            }
        });

        $('.js-popup').magnificPopup();

        $('.js-gallery').each(function () {
            $(this).magnificPopup({
                delegate: '.js-gallery-item',
                type: 'image',
                gallery: {
                    enabled: true
                }
            });
        });

        /**
         * SLIDER
         */
        $('.js-testimonial-slider').slick({
            arrows: false,
            dots: true,
            autoplay: true
        });

        $('.js-image-slider').slick({
            arrows: true,
            dots: false,
            prevArrow: '<a href="#" class="slick-prev"><svg role="presentation" class="icon"><use xlink:href="' + expl.svg + '#chevron-left"/></svg></a>',
            nextArrow: '<a href="#" class="slick-next"><svg role="presentation" class="icon"><use xlink:href="' + expl.svg + '#chevron-right"/></svg></a>',
            rows: 0
        });

        $('.js-slider').slick({
            arrows: false,
            dots: true,
            autoplay: false,
            rows: 0
        });

        /**
         * MASONRY
         */
        var $bloglist = $('.blog-list__list--gamma').imagesLoaded(function () {
            $bloglist.masonry({
                itemSelector: '.teaser'
            });
        });

        var $grid = $('.js-image-masonry').imagesLoaded(function () {
            $grid.each(function() {
                var width = this.getAttribute('data-width');
                $(this).masonry({
                    itemSelector: '.imagelist__item',
                    fitWidth: true,
                    isFitWidth: true,
                    gutter: 16
                });
            });
        });

        /**
         * COUNTER
         */
        $('.js-counter').each(function () {
            var $this = $(this),
                startVal = $this.data('start') || 0,
                endVal = $this.data('end');
            var counter = new CountUp(this, startVal, endVal, 0, 2.5, {
                useEasing: true,
                useGrouping: true,
                separator: ' ',
                decimal: ','
            });

            counter.start();
        })
    });
})(jQuery);